import _ from 'underscore'
import eBase from '@/base/eBase.js'

Date.prototype.Format = function(fmt) {
    var o = {
        "M+": this.getMonth() + 1, //月份
        "d+": this.getDate(), //日
        "h+": this.getHours(), //小时
        "m+": this.getMinutes(), //分
        "s+": this.getSeconds(), //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
}

export default {
    parserUrl(url, type) {

        type = type || 'obj';

        if (!url || "" == url) return false;

        var result = {};
        var params = {};
        if (url.indexOf("?") != -1) {
            var str = url.split("?")[1];
            var strs = str.split("&");
            for (var i = 0; i < strs.length; i++) {

                if ('obj' == type) {
                    params[strs[i].split("=")[0]] = strs[i].split("=")[1];
                } else {
                    var list = strs[i].split("=")[1].split(",");
                    params[strs[i].split("=")[0]] = list;
                }
            }

            result.url = url.split("?")[0];
            result.params = params;
        } else {
            result.url = url;
        }

        return result;
    },

    transformToSelect(data) {
        let result = [];
        let defaultValue = {};

        _.each(data, function(item, index) {
            if ('0' == index) defaultValue = { key: item.name }
            const one = { label: item.name, value: item.code, key: item.code }
            result.push(one);
        });
        return {
            list: result,
            defaultValue: defaultValue
        };
    },

    getTotal(arr, field) {
        var result = 0;
        field = field || 'value';
        _.each(arr, function(item) {
            result += item[field];
        })
        return result
    },

    getPercent(total, one) {
        if (total == 0) {
            return '0%';
        }
        var per = one * 100 / total;
        return per.toFixed(2) + '%';
    },

    getPercentByJindu(total, one, jindu) {
        if (total == 0) {
            return 0.00;
        }

        jindu = jindu || 2;
        var per = one * 100 / total;
        return per.toFixed(jindu);
    },

    getAccuratePercent(arr, field, one) {
        var result = 0;
        var self = this;
        var fixedTotal = 0,
            total = this.getTotal(arr, field);

        if (one[field] == '0') return result + '%';

        var minArr = _.min(arr, function(item) {
            var tempPercent = self.getPercentByJindu(total, item[field], 4);
            var thridValue = (tempPercent + '').split('').reverse().join('').charAt(2);
            return thridValue;
        });

        var newArr = [];

        _.each(arr, function(single, i) {
            if (!_.contains(minArr, single[field])) {
                newArr.push(single);
            }
        });

        if (_.contains(newArr, one)) {
            result = parseFloat(self.getPercentByJindu(total, one[field], 2));
        } else {
            _.each(newArr, function(_item, _index) {
                var tempPer = self.getPercentByJindu(total, _item[field], 2);
                fixedTotal += parseFloat(tempPer);
            });

            var shenTotal = 100 - fixedTotal;

            result = shenTotal;
        }

        return result.toFixed(2) + '%';
    },

    transform(data) {
        let result = [];
        _.each(data, function(item) {
            const one = { label: item.name, value: item.code, key: item.code }
            result.push(one);
        });
        return result;
    },

    //日期处理函数 2018-09-12

    getToday() {
        return new Date().Format('yyyy-MM-dd');
    },

    getSimpleToday() {
        return new Date().Format('yyyyMMdd');
    },

    getYesterday() {
        return new Date(new Date().getTime() - 24 * 60 * 60 * 1000).Format('yyyy-MM-dd');
    },

    getLastMonth() {
        var now = new Date();
        return new Date(now.getTime() - (now.getDate() + 1) * 24 * 60 * 60 * 1000).Format('yyyy-MM');
    },

    getLastMonthForDay() {
        var year = new Date().Format('yyyy');
        var month = parseInt(new Date().Format('MM')) - 1;
        var day = new Date().Format('dd');

        return new Date(year + '-' + month + '-' + day).Format('yyyy-MM-dd');
    },

    getThisMonth() {
        return new Date().Format('yyyy-MM');
    },

    getThisYear() {
        return new Date().Format('yyyy');
    },

    getLastYear() {
        return new Date().Format('yyyy') - 1;
    },

    getTwoYearAgo() {
        return new Date().Format('yyyy') - 2;
    },

    getThreeYearAgo() {
        return new Date().Format('yyyy') - 3;
    },
    //EOF 日期处理函数
}


// WEBPACK FOOTER //
// ./src/model/tool.js